<template>
  <LoginFormTitle v-show="getShow" class="enter-x" />
  <Form
    class="p-4 enter-x"
    :model="formData"
    :rules="getFormRules"
    ref="formRef"
    v-show="getShow"
    @keypress.enter="toNext"
  >
    <FormItem name="usernameOrEmail" class="enter-x">
      <Input
        size="large"
        v-model:value="formData.usernameOrEmail"
        :placeholder="t('sys.login.loginIdPlaceholder')"
        class="fix-auto-fill"
      >
        <template #prefix>
          <SvgIcon name="user" size="18" />
        </template>
      </Input>
    </FormItem>
    <FormItem class="enter-x">
      <Button type="primary" size="large" block @click="toNext" :loading="loading">
        {{ t('sys.login.nextStep') }}
      </Button>
    </FormItem>
    <FormItem :style="{ 'text-align': 'center' }">
      <a-button
        class="mx-2 !border-none text-[var(--primary-color-2)] cursor-pointer"
        @click="setLoginState(LoginStateEnum.REGISTER)"
      >
        {{ t('sys.login.registerQuickButton') }}
      </a-button>
      <Visitor v-if="!props.isModal" />
    </FormItem>
  </Form>
</template>
<script lang="ts" setup>
  import { reactive, ref, unref, computed } from 'vue';

  import { Form, Input, Button } from 'ant-design-vue';
  import { SvgIcon } from '/@/components/Icon';
  import LoginFormTitle from './LoginFormTitle.vue';

  import { useI18n } from '@mcex/locale';
  import { useUserStore } from '/@/store/modules/user';
  import { CheckAndGetAccounts } from '/@/api/sys/user';

  import { LoginStateEnum, useLoginState, useFormRules, useFormValid } from './useLogin';
  import Visitor from './Visitor.vue';
  const FormItem = Form.Item;

  const props = defineProps<{
    isModal: boolean;
  }>();
  const { t } = useI18n();

  const { getLoginState, setLoginState } = useLoginState();

  const userStore = useUserStore();
  const { getFormRules } = useFormRules();

  const formRef = ref(null);
  const { validForm } = useFormValid(formRef);

  const loading = ref(false);
  const formData = reactive({
    usernameOrEmail: '',
  });

  const getShow = computed(
    () => unref(getLoginState) === LoginStateEnum.CHECK_ACCOUNT_BEFORE_LOGIN,
  );

  const toNext = async () => {
    const data = await validForm();
    if (!data) return;

    loading.value = true;
    try {
      // 检查账号或邮箱是否存在，且是邮箱则返回账号列表
      const accounts = await CheckAndGetAccounts(formData);
      userStore.setUserNameOrEmail(formData.usernameOrEmail);
      userStore.setAccounts(accounts);
      setLoginState(LoginStateEnum.LOGIN);
    } catch (error) {
      console.log('CheckAndGetAccounts', error);
    } finally {
      loading.value = false;
    }
  };
</script>
